import React, { Component } from 'react';
import "./header.css";
import MobileHeader from "./MobileHeader";
import DesktopHeader from "./DesktopHeader";
export default class header extends Component {

    constructor(props) {
        super(props);

        this.state = { width: 0 }
        this.setSize = this.setSize.bind(this);
    }
    setSize() {
        this.setState({
            width: window.innerWidth
        });
    }

    componentDidMount() {
        this.setSize();
        window.addEventListener('resize', this.setSize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setSize);
    }

    render() {
        let content = this.state.width < 600 ? <MobileHeader /> : <DesktopHeader />;
        return (<div>{content}</div>)
    }
}

